import { useEffect, useRef, useState } from "react";
import { clamp } from "../../utils/helpers/math";

export const useSvgCircleProgress = (percent, hardCodedRadius = undefined) => {
  const circleRef = useRef(null);
  const [circumference, setCircumference] = useState(0);
  const [style, setStyle] = useState({});
  const circle = circleRef.current;
  const clampedPercentValue = clamp(0, 100)(percent);

  // on occasions the radius was not being returned randomly for no good reason
  // I have not removed t his code as ir really should work, however
  // the option to use a hard coded radius has been made.
  // if the cause of the issue can be found in the future we should swap the bellow to look like
  // so: const radius = circle?.r?.baseVal?.value || hardCodedRadius || 0;
  // as first paint might start animating with a radius of zero so it won't be as nice
  // than if we were to use hardCodedRadius as an optional guide to the radius.
  // this matters as if we resize later on the math might go a bit nutty and fixed won't work.
  // currently the size of the progression is fixed for our only use case so no point fixing for now
  const radius = hardCodedRadius ?? (circle?.r?.baseVal?.value || 0);

  useEffect(() => {
    setCircumference(radius * 2 * Math.PI)
  }, [radius]);

  useEffect(() => {
    if (circumference !== 0) {
      setStyle((prevState => ({
        ...prevState,
        strokeDasharray: `${circumference} ${circumference}`,
        strokeDashoffset: `${circumference - clampedPercentValue / 100 * circumference}`,
      })));
    }
  }, [circumference, clampedPercentValue, setStyle])

  return [circleRef, style];
};